import styled from 'styled-components'

export const FieldValueLength = styled.div`
    padding: 10.5px 0px 10.5px 10px;
    vertical-align: middle;
    text-align: end;
    min-width: fit-content;
`
